/* Common Imports */

import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";

/* Component Imports */

import { Paper, useMediaQuery } from "@material-ui/core";
import CarouselImage from "./sub-component/CarouselImage";
import CarouselVideo from "./sub-component/CarouselVideo";
import Carousel from "@beegru/react-material-ui-carousel";
import Skeleton from "@material-ui/lab/Skeleton";

/* Define all styles */

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: "0.5rem",
    marginTop: "1rem",
    marginBottom: "2rem",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    width: "100%",
  },
  containerStyling: {
    width: "100%",
  },
  carouselContainer: {
    height: "36rem",
    [theme.breakpoints.only("sm")]: {
      height: "27.5rem",
    },
    [theme.breakpoints.down("xs")]: {
      height: "18rem",
    },
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  carouselSkeleton: {
    width: "100%",
    height: "36rem",
    [theme.breakpoints.only("sm")]: {
      height: "27.5rem",
    },
    [theme.breakpoints.down("xs")]: {
      height: "18rem",
    },
    "&.MuiSkeleton-text": {
      transform: "none",
      margin: "2rem 0rem 2rem 0rem",
    },
  },
}));

const SPPCarousel = (props) => {
  const classes = useStyles();
  const theme = useTheme();

  if (!props.loading) {
    return (
      <React.Fragment>
        <Paper elevation={0} className={classes.paper}>
          <div className={classes.carouselContainer}>
            <Carousel
              navButtonsProps={{
                style: {
                  background: "-webkit-linear-gradient(#F74134, #EB1C61)",
                  boxShadow:
                    "0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)",
                },
              }}
              containerStyling={classes.containerStyling}
              animation="slide"
              navButtonsAlwaysVisible={useMediaQuery(
                theme.breakpoints.up("sm")
              )}
              navButtonsAlwaysInvisible={useMediaQuery(
                theme.breakpoints.down("xs")
              )}
              autoPlay={useMediaQuery(theme.breakpoints.up("sm"))}
              interval={15000}
            >
              {props.images ? (
                props.images.map((image, key) =>
                  image.video ? (
                    <CarouselVideo
                      thumbnailLink={image.url}
                      key={key}
                      imageAltText={image.caption}
                    />
                  ) : (
                    <CarouselImage
                      thumbnailLink={image.url}
                      key={key}
                      imageAltText={image.caption}
                    />
                  )
                )
              ) : (
                <CarouselImage thumbnailLink="/images/illustrations/common/ImageNotFound.svg" />
              )}
            </Carousel>
          </div>
        </Paper>
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <Skeleton className={classes.carouselSkeleton}></Skeleton>
      </React.Fragment>
    );
  }
};

export default SPPCarousel;
